import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface SimpleConfirmDialogData {
  title?: string;
  message: string;
  iconClass?: string;
  confirmText?: string;
  cancelText?: string;
}

@Component({
    selector: 'gtw-simple-confirm-dialog',
    template: `
    <div class="div-message-box animated fadeIn fast">
      <div class="message-box-container animated fadeIn fast">
        <div class="message-box-middle">
          <span class="msg-title">
            <i [class]="data.iconClass || 'fa fa-sign-out txt-color-orangeDark'"></i>
            {{ data.title || 'Confirm' }}
          </span>
          <p class="p-text">{{ data.message }}</p>
          <div class="message-box-button-section">
            <button class="btn btn-default btn-xs" (click)="onNo()">
              {{ data.cancelText || 'No' }}
            </button>
            <button class="btn btn-danger btn-xs" (click)="onYes()">
              {{ data.confirmText || 'Yes' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  `,
    styles: [`
    .div-message-box {
      padding: 0;
    }
    .message-box-container {
      text-align: center;
    }
    .message-box-middle {
      padding: 20px;
    }
    .msg-title {
      font-size: 16px;
      font-weight: 600;
      display: block;
      margin-bottom: 12px;
    }
    .msg-title i {
      margin-right: 6px;
    }
    .p-text {
      font-size: 14px;
      margin-bottom: 18px;
    }
    .message-box-button-section {
      display: flex;
      justify-content: center;
      gap: 10px;
    }
    .message-box-button-section .btn {
      min-width: 60px;
      padding: 5px 15px;
    }
  `],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SimpleConfirmDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SimpleConfirmDialogData,
    private dialogRef: MatDialogRef<SimpleConfirmDialogComponent>
  ) {}

  onYes(): void {
    this.dialogRef.close(true);
  }

  onNo(): void {
    this.dialogRef.close(false);
  }
}
